import { Pipe, PipeTransform, Injectable } from '@angular/core'

@Pipe({
    name: 'filter',
    pure: false
})
@Injectable()
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchString: string): any[] {
        if (!items) {
            return []
        }
        if (!searchString) {
            return items
        }

        searchString = searchString.toLowerCase()

        return items.filter((item: object) => {
            return this.findMatch(item, searchString)
        })
    }

    findMatch(item: object | any, searchString: string) {
        return Object.keys(item).some( (key: string) => {
            const value = item[key] ? item[key] : ''
            if (typeof value === 'object') {
                if (this.findMatch(value, searchString)) {
                    return true
                }

                return false
            }

            let check = false
            searchString.split(' ').forEach( (token: string): any => {
                if (value.toString().toLowerCase().includes(token)) {
                    check = true
                }
            })

            return check
        })
    }
}
